import styled from "styled-components";
import LunchMealsEdit from "./LunchMealsEdit";
import WeekMenu from "./WeekMenu";
import LunchMenu from "./WeekMenuEdit";

const TopGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3rem;
  padding: 1rem;
  box-sizing: border-box;
  flex: 1;
  /* overflow: hidden; */
`;

function LunchMenuEdit() {
  return (
    <TopGridContainer>
      <LunchMenu />
      <LunchMealsEdit />
    </TopGridContainer>
  );
}

export default LunchMenuEdit;
